import Seo from "@/components/Seo";
import { useWishlist } from "@/context/WishlistContext";
import { useProducts } from "@/context/ProductsContext";
import ProductCard from "@/components/ProductCard";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

export default function Wishlist() {
  const { ids, clear } = useWishlist();
  const { products } = useProducts();
  const items = products.filter(p => ids.includes(p.id));

  return (
    <div data-testid="page-wishlist" className="pt-32 pb-24">
      <Seo path="/wishlist" title="Wishlist" noindex />
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-end justify-between gap-6 flex-wrap">
          <div>
            <div className="overline">Wishlist</div>
            <h1 className="mt-4 font-serif font-light text-5xl lg:text-6xl leading-[1] tracking-tight">Saved pieces</h1>
            <p className="mt-4 text-sm text-[#2E2E2E]/70">{items.length} item{items.length === 1 ? "" : "s"} saved · stored locally on this device.</p>
          </div>
          {items.length > 0 && (
            <button data-testid="wishlist-clear" onClick={clear} className="text-xs uppercase tracking-[0.18em] underline underline-offset-4 hover:text-[#1A1A1A]">
              Clear wishlist
            </button>
          )}
        </div>

        <div className="mt-14">
          {items.length === 0 ? (
            <div data-testid="wishlist-empty" className="py-24 text-center border border-dashed border-[#E5E5E5] rounded-2xl">
              <Heart className="mx-auto h-8 w-8 text-[#C0C0C0]" strokeWidth={1.5} />
              <h3 className="mt-6 font-serif text-3xl">Nothing saved yet.</h3>
              <p className="mt-3 text-sm text-[#2E2E2E]/70">Tap the heart on any piece to keep it here.</p>
              <Link to="/shop" data-testid="wishlist-shop-cta" className="mt-8 inline-flex btn-fill h-12 px-7 rounded-full bg-[#1A1A1A] text-white text-xs uppercase tracking-[0.2em] items-center hover:text-white">Browse the shop</Link>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
              {items.map(p => <ProductCard key={p.id} product={p} />)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
